import { NavLink } from 'react-router-dom';
import {
  Home, CheckSquare, MessageSquare, Users, Calendar, Settings
} from 'lucide-react';
import clsx from 'clsx';

const NAV_ITEMS = [
  { to: '/', icon: Home, label: 'Início', exact: true },
  { to: '/tarefas', icon: CheckSquare, label: 'Tarefas', exact: false },
  { to: '/entrevistas', icon: MessageSquare, label: 'Entrevistas', exact: false },
  { to: '/chamados', icon: Users, label: 'Chamados', exact: false },
  { to: '/reunioes', icon: Calendar, label: 'Reuniões', exact: false },
];

const MORE_ITEMS = [
  { to: '/configuracoes', icon: Settings, label: 'Config.', exact: false },
];

export default function Navigation() {
  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-40 safe-bottom">
      <div className="max-w-2xl mx-auto flex">
        {[...NAV_ITEMS, ...MORE_ITEMS].map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.exact}
            className={({ isActive }) =>
              clsx(
                'flex-1 flex flex-col items-center justify-center py-2 gap-0.5 text-xs font-medium transition-colors min-w-0',
                isActive
                  ? 'text-brand-500'
                  : 'text-gray-400 hover:text-gray-600'
              )
            }
          >
            {({ isActive }) => (
              <>
                <item.icon
                  size={20}
                  className={clsx(isActive && 'stroke-brand-500')}
                  strokeWidth={isActive ? 2.5 : 1.5}
                />
                <span className="truncate w-full text-center">{item.label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
